<template>
  <q-list v-if="items.length" bordered separator class="rounded-borders">
      <item-link :href="$route('rule.show', {richtlijn: item.id})"
                 v-for="item in items" :key="item.id" linkClasses="items-center">
          <q-item-section avatar class="q-pr-lg">
              <count-chip :count="item.code" />
          </q-item-section>
          <q-item-section>
              <q-item-label lines="2">{{ item.latest_published_version.summary }}</q-item-label>
          </q-item-section>
      </item-link>
  </q-list>
</template>

<script>
export default {
  props: {
    items: {
      type: Object,
      default: () => {
        return {}
      }
    },
    category: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>
